import React from 'react'
import SettingPassword from 'src/containers/Auth/SettingPassword'

const SettingPasswordPage: React.FC = () => {
  return <SettingPassword />
}

export const PATH = '/pwd/setting/confirm' as const
export default SettingPasswordPage
